<template>
  <!-- The colour half of every swatch on the site: a checkerboard (so a
       translucent value stays legible), the fill, then the "belly" wave that
       pours it into the white panel below. Decorative — the hex beside it is
       the content.

       Both shapes are CSS backgrounds rather than <img> tags. Vite inlines
       small SVGs as data URIs, so an <img> per swatch repeated ~1 KB of base64
       in the prerendered HTML for every card — a brand page renders up to ~80
       of them. As background images they exist once, in this component's
       stylesheet.

       Sizes: `md` the generator and brand-page cards, `sm` the extension popup
       mock, `xs` the eyedropper magnifier. The negative margins tuck each edge
       under its neighbour so no hairline seam shows at fractional widths. -->
  <div class="relative" aria-hidden="true">
    <div class="swatch-checkerboard absolute inset-0"></div>
    <div class="relative" :class="FILL[size]" :style="{ backgroundColor: color }"></div>
    <div class="swatch-belly relative w-full" :class="BELLY[size]" :style="{ backgroundColor: color }"></div>
  </div>
</template>

<script setup>
defineProps({
  // Any CSS colour.
  color: { type: String, required: true },
  size: { type: String, default: 'md' },
})

const FILL = {
  xs: 'h-5',
  sm: 'h-9',
  md: '-mt-1 h-14',
}

const BELLY = {
  xs: '',
  sm: '-mt-px',
  md: '-mb-0.5',
}
</script>

<style scoped>
/* Sizes mirror the SVGs' intrinsic dimensions, so the tile and the wave draw
   exactly as the original <img> tags did. */
.swatch-checkerboard {
  background: url('~/assets/img/checkerboard_tile.svg') top left / 1600px 1600px no-repeat;
}

.swatch-belly {
  aspect-ratio: 69 / 9;
  background-image: url('~/assets/img/belly.svg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
